import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { find, isEmpty, isNil, reverse, split } from 'ramda';
import Avatar from '@components/@core/Avatar';
import AvatarButton from '@components/@core/AvatarButton';
import Button from '@components/@core/AnimatedButton';
import Icon from '@components/@core/Icon';
import Input from '@components/@core/Input';
import { AppActions, CommunityActions } from '~/actions';
import { getImageURL } from '~/services/util';
import withNavigate from '~/hocs/withNavigate';
import CommunityHeader from '~/views/Community/Community/Header';
import TopicList from './TopicList';

import QuillEditor from '@components/@core/QuillEditor';
const quillModules = {
    toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{ list: 'ordered' }, { list: 'bullet' }], ['link', 'image', 'video'], ['clean']],
    imageResize: { displaysize: true },
    'emoji-toolbar': true,
};

const Formats = ['header', 'font', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'color', 'video'];

class IndividualTopic extends React.Component {
    commentEndRef = React.createRef();
    topicRef = React.createRef();

    state = {
        topicId: this.props.match?.params?.topicId,
        departId: this.props.match?.params?.departId,
        file: null,
        preview: null,
        comment: '',
        openEmoji: false,
        reply: null,
        replyComment: '',
        adsData: [],
    };

    componentDidUpdate(prevProps) {
        if (prevProps.match?.params?.topicId !== this.props.match?.params?.topicId) {
            if (this.topicRef?.current) {
                this.topicRef.current.scrollIntoView({ behavior: 'smooth' });
            }
            this.setState({
                topicId: this.props.match?.params?.topicId,
                departId: this.props.match?.params?.departId,
            });
            this.props.getTopic({ topic_id: this.props.match?.params?.topicId });
            this.props.getTopics({
                category_id: this.props.match?.params?.departId,
                order: 'recent',
                page: 1,
                per_page: 10,
            });
        }
    }

    componentDidMount() {
        const { topicId, departId } = this.state;
        const { userId } = this.props;
        if (this.topicRef?.current) {
            this.topicRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        this.props.getTopic({ topic_id: topicId });
        this.props.getTopics({ category_id: departId, order: 'recent', page: 1, per_page: 10 });
        this.handleFetchAds();

        const payload = {
            data: {
                community_user_id: userId,
                events: [{ content_id: topicId, source: 'home', type: 'view' }],
            },
        };
        this.props.addEvent(payload);
    }

    handleFetchAds = () => {
        const adsData = [];
        window.broadstreetNative = (el, ads) => {
            adsData.push(ads);
            this.setState({ adsData });
        };
    };

    handleScrollToBottom = () => {
        const { topicId } = this.state;
        this.props.getTopic({ topic_id: topicId });
        if (this.commentEndRef?.current) {
            this.commentEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    handleFileDisplay = (e) => {
        const { comment, topicId, file } = this.state;
        let url = '';
        if (split('/', file.type)[0] === 'application') {
            url = `<a href=\'${e}\' download target="_blank" class="text-break">${file.name}</a>`;
        } else {
            url = `<a href=\'${e}\' download target="_blank"><img src=\'${e}\' height="50px" width="50px" /></a>`;
        }
        const payload = comment !== null ? { comment: { parent_id: topicId, data: { body: comment + url } } } : { comment: { parent_id: topicId, data: { body: url } } };

        this.props.addComment(payload, this.handleScrollToBottom);
        this.setState({ comment: null, preview: null, openEmoji: false, file: null });
    };

    handleCommentForm = () => {
        const { token } = this.props;
        const { comment, topicId, file } = this.state;
        const route = history.location.pathname;
        const payload = { comment: { parent_id: topicId, data: { body: comment } } };

        if (!isNil(file)) {
            const payload = { attachment_hash: null, file };
            this.props.upload(payload, this.handleFileDisplay);
        }
        if (token) {
            if (comment && !file) {
                this.props.addComment(payload, this.handleScrollToBottom);
                this.setState({ comment: null, preview: null, openEmoji: false, file: null });
            }
        } else {
            this.props.toggleModal({
                type: 'Authentication',
                data: { before: { route, after: { type: 'ADDTOPICCOMMENT_REQUEST', payload } } },
            });
        }
    };

    handleDrop = (file) => {
        if (file.length === 0) return;
        this.setState({ preview: file[0].name, file: file[0] });
    };

    handleSubmitReply = () => {
        const { reply, replyComment, topicId } = this.state;
        const payload = {
            comment: { parent_id: topicId, data: { body: replyComment, reply_id: reply.data?.reply_id } },
        };
        this.props.addComment(payload, this.handleScrollToBottom);
        this.setState({ reply: null, replyComment: null });
    };

    handleOpenProfile = (e) => {
        const payload = { userId: e.id, blogId: e.blog?.id };
        this.props.getUser(payload, `/${e?.slug ?? e?.entity?.slug}/about`);
    };

    handleLike = (e) => () => {
        const { token } = this.props;
        const { topicId } = this.state;
        if (token) {
            const payload = { contentId: e.id, flag: 'like' };
            const after = { type: 'GETFORUMINDIVIDUALTOPIC_REQUEST', payload: { topic_id: topicId } };
            this.props.addFlag(payload, after);
        }
    };

    handlereply = (reply) => () => {
        this.setState({ reply });
    };

    scrollToInputComment() {
        document.getElementById('input-comment')?.scrollIntoView({ behavior: 'smooth' });
    }

    render() {
        const { data, topics, departments, name, avatar, userId, navigate } = this.props;
        const { adsData, openEmoji, comment, departId, preview, reply, replyComment } = this.state;
        const department = find((e) => e.id === departId, departments);
        const relatedTopics = topics[departId];
        const relatedTopicsData = relatedTopics?.topics?.data?.slice(1, 5);
        const topic = data?.topics?.data[0];
        const comments = topic?.comments || [];
        const topicComment = comments.length > 0 && comments[0];
        const firstComment = comments[1];

        return (
            <div className="community-forum" ref={this.topicRef}>
                <broadstreet-zone zone-id="99535"></broadstreet-zone>
                <CommunityHeader activeRoute="Forums" childRoute={topic?.name} backTitle="all forums" onBack={() => navigate('/forums', { state: this.props.location?.state })} />
                <Helmet>
                    <meta property="og:type" content="article" />
                    <meta property="og:description" content={topic?.name} />
                    <meta property="og:title" content={topic?.name} />
                    <meta property="og:image" content={getImageURL(topicComment?.data?.body)} />
                </Helmet>
                {topic && (
                    <div className="p-3 bg-white">
                        <div className="d-flex ai-center p-1 mb-3 w-100">
                            <AvatarButton
                                avatar={topicComment?.author_avatar}
                                onClick={() => this.handleOpenProfile(topicComment?.user)}
                                companyName={topicComment?.user?.profile?.company}
                                username={`${topicComment?.user?.first_name} ${topicComment?.user?.last_name}`}
                            />
                            <div className="d-flex ps-2 w-100 ai-center">
                                <div className="d-flex-2 dsl-m12 text-400 text-end">
                                    <p>{department?.name || ''}</p>
                                    <p>{topic?.created_at && moment(topic.created_at).format('MMM DD, YY')}</p>
                                </div>
                            </div>
                        </div>
                        <div className="dsl-b18 bold mt-3 mb-3 ms-2">{topic?.name}</div>
                        <div className="dsl-b16 mb-2 lh-22 forum-body ms-2" dangerouslySetInnerHTML={{ __html: topicComment?.data?.body }} />
                        <div className="d-flex ai-center jc-between pb-1">
                            <div className="d-flex ai-center">
                                <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                                <span className="dsl-d14 me-4 text-400">{topic?.stats?.views || 0}</span>
                                <Button className="d-flex ai-center" type="link" onClick={this.handleLike(topic)}>
                                    <Icon name="fas fa-thumbs-up me-2 text-500" color={(topic?.stats?.liked && userId && topic?.stats?.liked[userId]) || 0 ? '#376CAF' : '#969faa'} size={12} />
                                    <span className={cx('dsl-d14 me-4 text-400', topic?.stats?.liked && userId && topic?.stats?.liked[userId] && 'forums-count')}>{topic?.stats?.likes || 0}</span>
                                </Button>
                                <Icon name="far fa-comment me-2 text-500" size={12} color={topic?.comments.some((comment) => comment.user_id === userId) ? '#376caf' : '#969faa'} />
                                <span className={cx('dsl-d14 text-400 me-2', topic?.comments.some((comment) => comment.user_id === userId) && 'forums-count')}>{topic?.stats?.comments ?? 0}</span>
                            </div>
                            <Button className="ml-2 mt-0 ssm-t-2" name="COMMENT" type="high" onClick={this.scrollToInputComment} />
                        </div>
                    </div>
                )}

                <div className="mt-3 p-3 bg-white">
                    <div className="dsl-b18 bold mt-3 mb-2">Comments</div>
                    <div>
                        <div className="forum-comments">
                            <div ref={this.commentEndRef} />
                            {reverse(comments.slice(1))?.map((item) => {
                                const { id, author_avatar, created_at, data, stats, user } = item;
                                const disableReply = !userId || !item.data?.reply_id || userId === item.user_id;
                                const replyId = item.data?.reply_id;
                                return (
                                    <div>
                                        <div className="d-table p-1 mt-3 w-100 inner-comment" key={`topic-${id}`}>
                                            {item.id !== replyId && item.data?.approved !== true ? (
                                                <div className="d-table p-1 mt-3 w-100 inner-comment ps-5">
                                                    <div className="d-flex jc-between">
                                                        <AvatarButton
                                                            avatar={author_avatar}
                                                            onClick={() => this.handleOpenProfile(user)}
                                                            companyName={user?.profile?.company}
                                                            username={`${user?.first_name} ${user?.last_name}`}
                                                        />
                                                        <div className="d-flex dsl-m12 text-400 text-end">
                                                            <span className="dsl-m12 me-2 mb-1 jc-end">{moment(created_at).format('MMM DD, YY')}</span>
                                                            <Icon name="fas fa-reply text-700" size={12} color="#969faa" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex p-1 w-100 ps-5">
                                                        <div className="w-100 border-bottom pb-3">
                                                            <div className="d-flex w-100">
                                                                <div className="d-flex flex-column w-100 mt-1">
                                                                    <div className="dsl-b16 mt-2 me-3" dangerouslySetInnerHTML={{ __html: data?.body }} />
                                                                </div>
                                                            </div>
                                                            <div className="d-flex mt-2 me-3">
                                                                <Button className="d-flex ai-center px-0" disabled={disableReply} type="link" onClick={this.handlereply(item)}>
                                                                    <Icon name="fas fa-reply me-2 text-700" size={12} color="#343f4b" />
                                                                    <span className="dsl-b14 me-4 text-400">Reply</span>
                                                                </Button>
                                                                <Button className="d-flex jc-start px-0 px-md-3" type="link" onClick={this.handleLike(item)}>
                                                                    <Icon
                                                                        name="fas fa-thumbs-up me-2 text-500"
                                                                        size={12}
                                                                        color={(stats?.liked && userId && stats?.liked[userId]) || 0 ? '#376CAF' : '#969faa'}
                                                                    />
                                                                    <span className={cx('dsl-d14 me-4 text-400', stats?.liked && userId && stats?.liked[userId] && 'forums-count')}>
                                                                        {stats?.likes || 0}
                                                                    </span>
                                                                </Button>
                                                                <div className="d-flex ai-center py-2 py-md-0">
                                                                    <Icon name="far fa-comment me-2 text-500" size={12} color="#969faa" />
                                                                    <span className="dsl-d14 text-400 me-2">{stats?.comments || 0}</span>
                                                                </div>
                                                            </div>
                                                            {reply?.id === id && (
                                                                <div className="input-comment">
                                                                    <div className="avatar-section">
                                                                        <Avatar type="logo" name={name} url={`${avatar}?${Date.now()}`} isSponsored={true} />
                                                                    </div>
                                                                    <div className="w-100 d-flex ssm-column">
                                                                        <div className="w-100 replay-comment">
                                                                            <QuillEditor
                                                                                className="w-80"
                                                                                value={replyComment}
                                                                                modules={quillModules}
                                                                                formats={Formats}
                                                                                onChange={(e) => this.setState({ replyComment: e })}
                                                                            />
                                                                        </div>
                                                                        <Button className="ml-2" type="medium" name="COMMENT" disabled={isEmpty(replyComment)} onClick={this.handleSubmitReply} />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="d-flex jc-between ai-center">
                                                        <AvatarButton
                                                            avatar={author_avatar}
                                                            onClick={() => this.handleOpenProfile(user)}
                                                            companyName={user?.profile?.company}
                                                            username={`${user?.first_name} ${user?.last_name}`}
                                                        />
                                                        <div className="d-flex dsl-m12 text-400 text-end">
                                                            <span className="dsl-m12 me-2 mb-1 jc-end">{moment(created_at).format('MMM DD, YY')}</span>
                                                            <Icon name="fas fa-reply text-700" size={12} color="#969faa" />
                                                        </div>
                                                    </div>
                                                    <div className="d-flex p-1 w-100 ps-5">
                                                        <div className="w-100 border-bottom pb-3">
                                                            <div className="d-flex w-100">
                                                                <div className="dsl-b16 mt-2 me-3" dangerouslySetInnerHTML={{ __html: data?.body }} />
                                                            </div>
                                                            <div className="d-flex mt-2 me-3">
                                                                <Button className="d-flex ai-center px-0" disabled={disableReply} type="link" onClick={this.handlereply(item)}>
                                                                    <Icon name="fas fa-reply me-2 text-700" size={12} color="#343f4b" />
                                                                    <span className="dsl-b14 me-4 text-400">Reply</span>
                                                                </Button>
                                                                <Button className="d-flex jc-start px-0 px-md-3" type="link" onClick={this.handleLike(item)}>
                                                                    <Icon
                                                                        name="fas fa-thumbs-up me-2 text-500"
                                                                        size={12}
                                                                        color={(stats?.liked && userId && stats?.liked[userId]) || 0 ? '#376CAF' : '#969faa'}
                                                                    />
                                                                    <span className={cx('dsl-d14 me-4 text-400', stats?.liked && userId && stats?.liked[userId] && 'forums-count')}>
                                                                        {stats?.likes || 0}
                                                                    </span>
                                                                </Button>
                                                                <div className="d-flex ai-center py-2 py-md-0">
                                                                    <Icon name="far fa-comment me-2 text-500" size={12} color="#969faa" />
                                                                    <span className="dsl-d14 text-400 me-2">{stats?.comments || 0}</span>
                                                                </div>
                                                            </div>
                                                            {reply?.id === id && (
                                                                <div className="input-comment">
                                                                    <div className="avatar-section">
                                                                        <Avatar type="logo" name={name} url={`${avatar}?${Date.now()}`} />
                                                                    </div>
                                                                    <div className="w-100 d-flex ssm-column">
                                                                        <div className="w-100 replay-comment">
                                                                            <QuillEditor
                                                                                placeholder="Type a comment"
                                                                                theme="snow"
                                                                                value={replyComment}
                                                                                formats={Formats}
                                                                                modules={quillModules}
                                                                                onChange={(e) => this.setState({ replyComment: e })}
                                                                            />
                                                                        </div>
                                                                        <Button className="ml-2" type="medium" name="COMMENT" disabled={isEmpty(replyComment)} onClick={this.handleSubmitReply} />
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    <div className="input-comment ms-2" id="input-comment">
                        <div className="avatar-section">
                            <Avatar type="logo" name={name} url={`${avatar}?${Date.now()}`} />
                        </div>
                        <div className="d-flex ssm-column individual-comments">
                            <div className="comment-box">
                                <QuillEditor
                                    placeholder="Type a comment..."
                                    theme="snow"
                                    value={comment}
                                    formats={Formats}
                                    modules={quillModules}
                                    onChange={(e) => this.setState({ comment: e })}
                                />
                            </div>
                            <Button className="ml-2 mt-0 ssm-t-2" name="COMMENT" type="high" disabled={isEmpty(comment)} onClick={this.handleCommentForm} />
                        </div>
                    </div>
                </div>

                <div className="p-3 mt-3 bg-white">
                    <span className="dsl-b20 bold mb-4 ms-2">Related Topics</span>
                    <TopicList displayMenu data={relatedTopicsData} adsData={adsData} userId={userId} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userId: state.app.user?.community_user?.id,
    token: state.app.token,
    name: state.app.user_name,
    avatar: state.app.avatar,
    data: state.community.individualTopic,
    topics: state.community.topics,
    departments: state.company.blogCategories,
});

const mapDispatchToProps = (dispatch) => ({
    addComment: (e, cb) => dispatch(CommunityActions.addtopiccommentRequest(e, cb)),
    getTopics: (e) => dispatch(CommunityActions.gettopicsRequest(e)),
    getTopic: (e, route) => dispatch(CommunityActions.getforumindividualtopicRequest(e, route)),
    getUser: (payload, route) => dispatch(CommunityActions.getcommunityuserRequest(payload, null, route)),
    addFlag: (payload, after) => dispatch(CommunityActions.postcontentflagRequest(payload, null, after)),
    addEvent: (payload) => dispatch(CommunityActions.addcontenteventRequest(payload)),
    toggleModal: (payload) => dispatch(AppActions.modalRequest(payload)),
    upload: (e, cb) => dispatch(AppActions.uploadRequest(e, cb)),
});

const IndividualTopicWithNavigate = withNavigate(IndividualTopic);

export default connect(mapStateToProps, mapDispatchToProps)(IndividualTopicWithNavigate);
